import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { ApiError } from './api/client';
import { App } from './App';
import { AuthProvider } from './auth/auth-context';
import { initTheme } from './lib/theme';
import './styles.css';

// Antes del primer render: si el usuario forzó un tema, que no parpadee el del sistema.
initTheme();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // Reintentar un 4xx no arregla nada: el problema es la petición, no la red. Un
        // 401 además ya lo maneja el cliente renovando la sesión.
        if (error instanceof ApiError && error.status < 500) return false;
        return failureCount < 2;
      },
    },
    mutations: {
      // Una mutación escribe en el router; repetirla a ciegas podría duplicar efectos.
      retry: false,
    },
  },
});

const container = document.getElementById('root');
if (!container) throw new Error('No se encontró el nodo #root');

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      {/* `BASE_URL` viene de `vite build --base=...`: '/' en desarrollo y '/panel/' en
          producción, donde el panel convive con la app antigua en el mismo dominio. */}
      <BrowserRouter basename={import.meta.env.BASE_URL}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
